<template>
  <div>
    <div class="g-bg-img-hero" :style="{ 'background-image': 'url(' + colleague_bg + ')' }">
      <section class="clearfix">
        <div class="js-bg-video" data-hs-bgv-type="youtube" data-hs-bgv-id="FxiskmF16gU" data-hs-bgv-loop="1">
          <div class="g-bg-cover g-bg-black-opacity-0_6--after g-pos-rel g-z-index-1">
            <div class="container text-center g-pos-rel g-z-index-1 g-pt-20 g-pb-40">
              <div class="g-mb-40">
                <h1 class="g-color-white g-font-size-60--lg">Invite a colleague</h1>
                <p class="g-color-white-opacity-0_8 g-font-size-20">
                  The only way we can solve this problem is by all working together. Enter the email address of another office or a professional colleague, and we’ll send them an invite to sign up for Champions for Sight®!
                </p>
              </div>
              <form class="g-max-width-645 mx-auto">
                <input class="form-control g-brd-none g-font-size-16 g-rounded-30 g-px-30 g-py-14 g-mb-20" type="text" placeholder="Enter Email Address" v-model="EmailAddress" v-validate="'required|email'" data-vv-as="email address">
                <p v-if="errorMessage" style="color: white">{{errorMessage}}</p>
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-12 g-mt-10">
                    &nbsp;
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 g-mt-10">
                    <button v-on:click="Referral('Colleague')" class="btn btn-block g-color-white g-color-main--hover g-bg-primary g-bg-white--hover g-rounded-30 g-py-13 g-font-size-18--md g-font-size-17" type="button">
                      Invite a colleague
                    </button>
                  </div>
                </div>
              </form>
              <div v-if="isModalShown">
                <div class="modal-mask g-z-index-2" role="dialog">
                  <div class="overlay-mask">
                    <div class="modal-dialog modal-md g-mt-100 g-z-index-10">
                      <div class="modal-content modal-edit-bg">
                        <div class="modal-body">
                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                              <div class="close_btn" v-on:click="CloseModal()"></div><br>
                              <div class="text-center">
                                <h5 class="g-px-40 g-pb-20">Thank you for sharing the program! <br>Your colleague will receive an email to register.</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import LoadingComponent from "@/components/shared/LoadingComponent";
export default {
  components: { LoadingComponent},
  data() {
    return {
      isModalShown: false,
      EmailAddress: "",
      errorMessage: null,
      ResetStatus: false,
      ResetForm: true,
      isLoading: false,
      donationIcon: '../../../../static/assets/img/icons/Home Page Icons/money_inv.png',
      communityIcon: '../../../../static/assets/img/icons/Home Page Icons/hehc_inv.png'
    }
  },
  methods: {
    CloseModal() {
      this.isModalShown = false;
    },
    Referral(referralType) {
      this.errorMessage = null;
      axios.post("/Account/Referral", { "EmailAddress": this.EmailAddress, "Type": referralType }, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      })
        .then(response => {
          var _this = this;
          if (response.data.isSuccess == true) {
            _this.isModalShown = true;
            _this.EmailAddress = "";
          } else {
            _this.errorMessage = response.data.errorMessage;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    HoverDonation(event) {
      if(event == 'enter'){
        this.donationIcon = '../../../../static/assets/img/icons/Home Page Icons/money.png';
      }
      else if(event == 'leave'){
        this.donationIcon = '../../../../static/assets/img/icons/Home Page Icons/money_inv.png';
      }
    },
    HoverCommunity(event) {
      if(event == 'enter'){
        this.communityIcon = '../../../../static/assets/img/icons/Home Page Icons/hehc.png';
      }
      else if(event == 'leave'){
        this.communityIcon = '../../../../static/assets/img/icons/Home Page Icons/hehc_inv.png';
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// HomeInvite.vue?7db406b6